(function () {
    let formContainer = document.querySelector('.feedback-form');
    let formElement = formContainer.querySelector('.feedback-form__form');

    let textareaEl = formContainer.querySelector('textarea');
    let attachInputEl = formContainer.querySelector('.feedback-form__attachment-input');
    let attachLabelEl = formContainer.querySelector('.feedback-form__attachment-label');
    let attchedNameEl = formContainer.querySelector('.feedback-form__attached-name');
    let attchedBlockEl = formContainer.querySelector('.feedback-form__attached-wrapper');
    let attchedDelBtn = formContainer.querySelector('.feedback-form__attached-delete');
    let fallsendBtn = formContainer.querySelector('.feedback-form__falling-btn');

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    textareaEl.addEventListener('keyup', function(){
    if(this.scrollTop > 0){
        this.style.height = this.scrollHeight + "px";
    }
    });

    attachInputEl.addEventListener('input', function (evt) {
        const maxAttachWeight = 5242880;
        
        if (attachInputEl.files[0].size > maxAttachWeight) {
            attchNameEl.innerHTML = 'Файл больше 5мб, выберите файл меньшего размера';
        } else {
            attchedBlockEl.classList.toggle('feedback-form__attached-wrapper--show');
            attchedNameEl.innerHTML = attachInputEl.files[0].name;
            attachLabelEl.innerHTML = 'файл загружен';
            attachLabelEl.classList.toggle('feedback-form__attachment-label--attached');
        }
    });

    attchedDelBtn.addEventListener('click', function () {
        attchedBlockEl.classList.toggle('feedback-form__attached-wrapper--show');
        attachLabelEl.innerHTML = 'прикрепить файл';
        attachLabelEl.classList.toggle('feedback-form__attachment-label--attached');
        attachInputEl.value = '';
    });

    fallsendBtn.addEventListener('click', function() {
        formContainer.classList.toggle('feedback-form--fall-send');
    })
    formElement.addEventListener('submit', function (evt) {
        evt.preventDefault();
        let formData = new FormData(this);
        let url = '/local/ajax/form_ajax.php';
        return fetch(url, {
            method:'post', 
            body: formData,
            headers: {
                'Accept': 'application/json',
            },
        }).then(async response => {
            let serverResp = await response.json();
            if (serverResp.status === 'OK') {
                ym(51656255,'reachGoal','question');
                gtag('event', 'question', {'event_category': 'proposal', 'send_to': 'UA-131383161-1'});
                formElement.parentNode.classList.add('feedback-form--send');
            } else {
                throw new Error('Отправка формы не удалась');
            }
        }).catch(() => {
            formElement.parentNode.classList.add('feedback-form--fall-send');
        });
    });
}());